import React, { useState, useEffect } from 'react';
import { Megaphone } from 'lucide-react';
import api from '../../services/api';

// Set the one-line status banner shown across the client portal. Reusable for
// every deploy and for wave 1.
export default function PortalBannerAdmin() {
  const [message, setMessage] = useState('');
  const [active, setActive] = useState(false);
  const [level, setLevel] = useState('info');
  const [saved, setSaved] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get('/portal-banner').then((r) => {
      setMessage(r.data.message || '');
      setActive(!!r.data.active);
      setLevel(r.data.level || 'info');
    }).catch(() => {});
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      await api.put('/portal-banner', { message, active, level });
      setSaved(true); setTimeout(() => setSaved(false), 2500);
    } catch (e) { alert(e.response?.data?.detail || 'Save failed'); }
    finally { setBusy(false); }
  };

  return (
    <div className="mb-4 p-4 rounded-lg border border-virgo-teal-700/40 bg-virgo-navy-800/40">
      <div className="flex items-center gap-2 mb-2">
        <Megaphone className="w-4 h-4 text-virgo-teal-300" />
        <span className="text-virgo-teal-100 text-sm font-semibold">Client Portal Banner</span>
      </div>
      <input
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="e.g. iPhone document downloads are being fixed — expected today."
        className="w-full px-3 py-1.5 bg-virgo-navy-900 border border-virgo-teal-700/40 rounded text-sm text-white"
      />
      <div className="flex items-center gap-3 mt-2">
        <label className="flex items-center gap-1.5 text-sm text-virgo-navy-100">
          <input type="checkbox" checked={active} onChange={(e) => setActive(e.target.checked)} />
          Show on portal
        </label>
        <select value={level} onChange={(e) => setLevel(e.target.value)}
          className="bg-virgo-navy-900 border border-virgo-teal-700/40 rounded text-sm text-white px-2 py-1">
          <option value="info">Info</option>
          <option value="warning">Warning</option>
        </select>
        <button onClick={save} disabled={busy}
          className={`ml-auto px-3 py-1.5 rounded text-sm text-white ${saved ? 'bg-emerald-600' : 'bg-virgo-teal-600 hover:bg-virgo-teal-700'}`}>
          {saved ? 'Saved' : busy ? 'Saving…' : 'Save banner'}
        </button>
      </div>
    </div>
  );
}
